<template>
  <v-card 
    flat
    class="my-3 pa-3"
    width="100%"
  >  
    <h2>{{ $t('limit-condition-number') }}</h2><br>
    <div v-if="firstTabStatus"> 
      <b>{{ $t('bet-condition') }}</b>:{{ firstTab.number_type.name }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ firstTab.max_number_per_list }} {{ $t('unit.number-per-list') }} <br>
      {{ $t('number-condition.maximum-bet') }} {{ firstTab.max_number_per_user }} {{ $t('unit.number-per-user') }} <br> 
      {{ $t('number-condition.maximum-bet') }} {{ firstTab.max_unit_per_number_per_list }} {{ $t('unit.unit-per-number-per-list') }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ firstTab.max_unit_per_number_per_user }} {{ $t('unit.unit-per-number-per-user') }}<br>
      {{ $t('number-condition.at-least-bet') }} {{ firstTab.min_unit_per_list }} {{ $t('unit.unit-per-list') }}<br>
      {{ $t('number-condition.bet-limit') }} {{ firstTab.max_list_per_user }} {{ $t('unit.list-per-user') }}<br>
      <br>
    </div>
    <div v-if="!secondTab.Is_empty&&secondTabStatus">
      <b>{{ $t('bet-condition') }}</b>:{{ secondTab.number_type.name }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ secondTab.max_number_per_list }} {{ $t('unit.number-per-list') }} <br>
      {{ $t('number-condition.maximum-bet') }} {{ secondTab.max_number_per_user }} {{ $t('unit.number-per-user') }} <br> 
      {{ $t('number-condition.maximum-bet') }} {{ secondTab.max_unit_per_number_per_list }} {{ $t('unit.unit-per-number-per-list') }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ secondTab.max_unit_per_number_per_user }} {{ $t('unit.unit-per-number-per-user') }}<br>
      {{ $t('number-condition.at-least-bet') }} {{ secondTab.min_unit_per_list }} {{ $t('unit.unit-per-list') }}<br>
      {{ $t('number-condition.bet-limit') }} {{ secondTab.max_list_per_user }} {{ $t('unit.list-per-user') }}<br>
      <br>
      <!-- <b>เงื่อนไขการแทง</b>:{{ secondTab.number_type.name }}<br>
      แทงทุกเลขขั้นต่ำ : {{ secondTab.min_unit_per_list }} ต่อครั้ง <br>
      แทงทุกเลขสูงสุด : {{ secondTab.max_number_per_list }} ต่อครั้ง <br>
      แทงทุกเลขสูงสุด : {{ secondTab.max_number_per_user }} ต่อคน <br> 
      แทงสูงสุดต่อเลข : {{ secondTab.max_unit_per_number_per_list }} ครั้งต่อเลข <br>
      แทงทุกเลขเลขสูงสุดต่อคน : {{ secondTab.max_unit_per_number_per_user }} ต่อคน <br>
      จำนวนครั้งการแทงสูงสุด : {{ secondTab.max_list_per_user }} ครั้งต่อคน<br>
      <br> -->
    </div>
    <div  
      v-for="(winTab, index) in winTabs" 
      :key="index"
    > 
      <b>{{ $t('bet-condition') }}</b>:{{ winTab.number_type.name }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ winTab.max_number_per_list }} {{ $t('unit.number-per-list') }} <br>
      {{ $t('number-condition.maximum-bet') }} {{ winTab.max_number_per_user }} {{ $t('unit.number-per-user') }} <br> 
      {{ $t('number-condition.maximum-bet') }} {{ winTab.max_unit_per_number_per_list }} {{ $t('unit.unit-per-number-per-list') }}<br>
      {{ $t('number-condition.maximum-bet') }} {{ winTab.max_unit_per_number_per_user }} {{ $t('unit.unit-per-number-per-user') }}<br>
      {{ $t('number-condition.at-least-bet') }} {{ winTab.min_unit_per_list }} {{ $t('unit.unit-per-list') }}<br>
      {{ $t('number-condition.bet-limit') }} {{ winTab.max_list_per_user }} {{ $t('unit.list-per-user') }}<br>
      <br>
    </div>
  </v-card>
</template>
<script>
export default {
  props: { 
    firstTab: {
      type:[Object,Boolean],
      default:()=>{}
    },
    secondTab: {
      type:[Object,Boolean],
      default:()=>{
        return {
          status : false,
          Is_empty : true
        }
      }
    },
    firstTabStatus: {
      type:Boolean,
      default:false
    }, 
    secondTabStatus: {
      type:Boolean,
      default:false
    },
    winTabs: {
      type: Array,
      default: () => {
        return []
      }
    }
  }, 
}
</script>